<template>
    <div class="control">
        <div class="container control-buttons justify-content-center">
            <div class="row justify-content-around">
                <div
                    class="
                        col-12 col-sm-auto
                        ml-3
                        d-flex
                        justify-content-center
                    "
                >
                    <div
                        class="
                            d-flex
                            justify-content-center
                            align-items-center
                            control-nowplay
                        "
                    >
                        <p>{{ playingButtonDesc }}</p>
                    </div>
                </div>
                <div class="col-12 col-sm-6 d-flex justify-content-around">
                    <div
                        @click="playAll"
                        class="
                            control-button
                            d-flex
                            justify-content-center
                            align-items-center
                        "
                    >
                        <img
                            src="../assets/pic/outline_play_circle_filled_white_36dp.png"
                        />
                    </div>
                    <div
                        @click="playHistory"
                        class="
                            control-button
                            d-flex
                            justify-content-center
                            align-items-center
                        "
                    >
                        <img src="../assets/pic/play_arrow_white_36dp.png" />
                    </div>
                    <div
                        @click="stopSound"
                        class="
                            control-button
                            d-flex
                            justify-content-center
                            align-items-center
                        "
                    >
                        <img src="../assets/pic/stop_white_36dp.png" />
                    </div>
                    <div
                        @click="prev"
                        class="
                            control-button
                            d-flex
                            justify-content-center
                            align-items-center
                        "
                    >
                        <img src="../assets/pic/skip_previous_white_36dp.png" />
                    </div>
                    <div
                        @click="next"
                        class="
                            control-button
                            d-flex
                            justify-content-center
                            align-items-center
                        "
                    >
                        <img src="../assets/pic/skip_next_white_36dp.png" />
                    </div>
                    <div
                        @click="playRandomAll"
                        class="
                            control-button
                            d-flex
                            justify-content-center
                            align-items-center
                        "
                    >
                        <img
                            src="../assets/pic/outline_shuffle_on_white_36dp.png"
                        />
                    </div>
                    <div
                        @click="playRandom"
                        class="
                            control-button
                            d-flex
                            justify-content-center
                            align-items-center
                        "
                    >
                        <img src="../assets/pic/shuffle_white_36dp.png" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AudioSourcePlayable from '@/mixins/AudioSourcePlayable'
import store from '@/store/store'
import history from  '@/store/modules/history'

export default {
    name: 'Control',
    mixins: [AudioSourcePlayable],
    data: function() {
        return {
            sharedState: history.state,
        }
    },
    computed: {
        playingButtonDesc: function () {
            const item = store.history.getHistorySelectedItem()
            if (item == null) {
                return ''
            }
            return item.buttonDesc
        },
    },
}
</script>

<style scoped>
.control {
    position: fixed;
    bottom: 10px;
    left: 50%;
    transform: translateY(0%) translateX(-50%);
    width: 100%;
}
.control-nowplay {
    max-width: 250px;
    min-width: 250px;
    max-height: 3em;
    min-height: 3em;
    padding: 0;
    margin: 0;
    background-color: rgba(255, 255, 255, 0.5);
    border-radius: 10px 10px;
}
.control-nowplay p {
    padding: 0;
    margin: 0;
    overflow: hidden;
    font-size: small;
}
.control-buttons {
    max-width: 600px;
    background-color: rgba(0, 0, 0, 0.8);
    border: solid;
    border-color: rgba(0, 0, 0, 0.2);
    border-radius: 10px 10px;
}
.control-button img {
    margin: 10px 0px;
    width: 30px;
    height: 30px;
}
</style>
